import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import Ad from '../ad/';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Logo from './logo/';
import Nav from '@ifeng-fe/container_channel/common/client/spring/components/nav';
import UserInfo from '@ifeng-fe/ui_pc_userInfo';
import Search from '@ifeng-fe/ui_pc_search';

/**
 * 定义 Header 组件
 */
class Header extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    sliderTmpl = item => {
        return <Ad content={item} />;
    };

    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;

        const logoData = {
            logo: content.logo,
            subLogo: content.subLogo,
        };

        const SearchComp = errorBoundary(Search);

        const topNav = (
            <div id="main_nav" className={styles.main_nav} key="topNav">
                <Chip id="20002" type="struct" title="导航" groupName="头部" content={content.nav}>
                    <Nav />
                </Chip>
                <div className={styles.user}>
                    <UserInfo />
                </div>
            </div>
        );

        const topSearch = (
            <div className={styles.search} key="topSearch">
                <div className={styles.logo}>
                    <Logo content={logoData} />
                </div>
                <Chip id="20005" type="struct" title="搜索" groupName="头部" content={content.search}>
                    <SearchComp />
                </Chip>
            </div>
        );

        return [topNav, topSearch];
    }
}

export default errorBoundary(Header);
